<template>
    <div id="Category">
        <template v-if="app.template.type === '92fanli'">
            <header class="Mybar bg_white">
                <div class="mybarLeft lh30" v-on:click="toPrev"><span
                        class="iconfont icon-zuojiantou f12 color_999"></span></div>
                <div class="searchBoxClassify_92fanli rel" v-on:click="toSearch">
                    <span class="iconfont icon-sousuo iconSearch f12 color_999"></span>
                    <input type="text" class="searchInput_92fanli" placeholder="输入商品名称或粘贴淘宝标题"
                           disabled="disabled" />
                </div>
            </header>

            <main class="MainCon bg_white bottom0 myborderT">
                <div class="classifyLeftBox">
                    <ul :class="{'classifyLeftList_92fanli':app.template.style === 'main','classifyLeftList_92fanli_red':app.template.style === 'main_b','classifyLeftList_92fanli_yellow':app.template.style === 'main_c'}">
                        <li v-bind:class="{current:currentIndex === index}"
                            v-for="(item,index) in leftList"
                            v-on:click="tabCategory(index)" :key="index">{{item.name}}
                        </li>
                    </ul>
                </div>

                <div class="classifyRightBox">
                    <ul class="goodInfoBoxList pt10">
                        <li class="flexBox-cell-33" v-for="(item,index) in rightList" :key="index"
                            v-on:click="toTopGoodsList(item.name)">
                            <div class="classifyimg"><img v-bind:src="item.img_path" /></div>
                            <p class="f10 lh24 tc">{{item.name}}</p>
                        </li>
                    </ul>
                </div>
            </main>
        </template>
        <template v-else-if="app.template.type === 'damai'">
            <header class="Mybar bg_white">
                <div class="mybarLeft lh30" v-on:click="toPrev"><span
                        class="iconfont icon-zuojiantou f12 color_999"></span></div>
                <div class="searchBoxClassify_damai rel" v-on:click="toSearch">
                    <span class="iconfont icon-sousuo iconSearch f12 color_999"></span>
                    <input type="text" class="searchInput_damai" placeholder="输入商品名称或粘贴淘宝标题"
                           disabled="disabled" />
                </div>
            </header>

            <main class="MainCon bg_white bottom0">
                <div class="classifyLeftBox">
                    <ul :class="{'classifyLeftList_damai':app.template.style === 'main','classifyLeftList_damai_yellow':app.template.style === 'main_b','classifyLeftList_damai_green':app.template.style === 'main_c'}">
                        <li v-bind:class="{current:currentIndex === index}"
                            v-for="(item,index) in leftList"
                            v-on:click="tabCategory(index)" :key="index">{{item.name}}
                        </li>
                    </ul>
                </div>

                <div class="classifyRightBox">
                    <ul class="goodInfoBoxList pt10">
                        <li class="flexBox-cell-33" v-for="(item,index) in rightList" :key="index"
                            v-on:click="toTopGoodsList(item.name)">
                            <div class="classifyimg"><img v-bind:src="item.img_path" /></div>
                            <p class="f10 lh24 tc">{{item.name}}</p>
                        </li>
                    </ul>
                </div>
            </main>
        </template>
        <template v-else>
            <header class="Mybar"
                    :class="{'bg_use':app.template.style === 'main','bg_red':app.template.style === 'main_b','bg_green':app.template.style === 'main_c'}">
                <div class="mybarLeft lh30" v-on:click="toPrev"><span
                        class="iconfont icon-zuojiantou f12 color_fff"></span></div>
                <div class="searchBoxCategory rel" v-on:click="toSearch">
                    <span class="iconfont icon-sousuo iconSearch f12 color_999"></span>
                    <input type="text" class="searchInput" placeholder="输入商品名称或粘贴淘宝标题"
                           disabled="disabled" />
                </div>
            </header>

            <main class="MainCon bg_white bottom0">
                <div class="classifyLeftBox">
                    <ul :class="{'classifyLeftList':app.template.style === 'main','classifyLeftList_red':app.template.style === 'main_b','classifyLeftList_green':app.template.style === 'main_c'}">
                        <li v-bind:class="{current:currentIndex === index}"
                            v-for="(item,index) in leftList"
                            v-on:click="tabCategory(index)" :key="index">{{item.name}}
                        </li>
                    </ul>
                </div>

                <div class="classifyRightBox">
                    <ul class="goodInfoBoxList pt10">
                        <li class="flexBox-cell-33" v-for="(item,index) in rightList" :key="index"
                            v-on:click="toTopGoodsList(item.name)">
                            <div class="classifyimg"><img v-bind:src="item.img_path" /></div>
                            <p class="f10 lh24 tc">{{item.name}}</p>
                        </li>
                    </ul>
                </div>
            </main>
        </template>
    </div>

</template>

<script>
    import {mapState} from 'vuex';
    import {appService} from '../services/app';
    import {isMobile} from '../libs/utils';

    export default {
        data() {
            return {
                currentIndex: 0,
                leftList: [],
                rightList: [],
            }
        },
        computed: {
            ...mapState(['app'])
        },
        created() {
            if (!isMobile()) {
                window.location.href = window.location.origin;
            }
            this.fetchCategoryList();
        },
        methods: {
            fetchCategoryList: function () {
                let self = this;
                appService.fetchCategoryList().then((res) => {
                    let {code, data} = res;
                    if (code === 200) {
                        self.leftList = data;
                        self.setRightList();
                    }
                });
            },
            setRightList: function () {
                this.rightList = this.leftList[this.currentIndex]['children'];
            },
            toPrev: function () {
                if (this.app.history.length <= 1) {
                    this.$router.push('/')
                } else {
                    this.$router.back();
                }
            },
            toSearch: function () {
                this.$router.push({name: 'search'});
            },
            tabCategory: function (index) {
                this.currentIndex = index;
                this.setRightList();
            },
            toTopGoodsList: function (q) {
                const route = {
                    name: 'top-goods-list',
                    query: {
                        q: q
                    }
                };
                this.$router.push(route);
            }
        }
    }
</script>

<style scoped>

</style>
